import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import Dev1 from '../../../Componet/Develoment/dev1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function DevelopmentHePage() {
    return (
        <div className="development-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - פיתוח תוכנה</title>
                <meta
                    name="description"
                    content="פיתוח תוכנה בהתאמה אישית, מוצרי SaaS ואינטגרציות לעסקים שצריכים מערכת נכונה, יציבה וברת תחזוקה."
                />
                <meta
                    name="keywords"
                    content="פיתוח תוכנה, פיתוח תוכנה בהתאמה אישית, פיתוח SaaS, אינטגרציות, שדרוג מערכות, חברת פיתוח תוכנה"
                />
                <meta property="og:title" content="EpicFinal - פיתוח תוכנה" />
                <meta
                    property="og:description"
                    content="מערכות מותאמות לעסק, פיתוח מוצרי SaaS ואינטגרציות עם חשיבה על יציבות, צמיחה ותחזוקה נכונה."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/development" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - פיתוח תוכנה" />
                <meta
                    name="twitter:description"
                    content="פיתוח תוכנה לעסקים שצריכים מערכת נכונה, לא רק קוד שעובד."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"פיתוח תוכנה"} />
            <div className="page-content">
                <Dev1 />
                <ConsultingForm
                    language="he"
                    formId="epic-development-form"
                    conversionSendTo="AW-11461100984/z9qBCKeatJgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו מה אתם צריכים לפתח"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית למערכת שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default DevelopmentHePage

